import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';

import {
  FormControl,
  FormHelperText,
  FormLabel,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import type { ToggleButtonGroupProps } from '@mui/material';

interface Props extends ToggleButtonGroupProps {
  control: Control<any>;
  name: string;
  label?: string;
  inputToggleButtons: {
    label: string;
    value: string | number;
    selected: boolean;
    disabled?: boolean;
  }[];
}

export default function ControlledToggleButtonGroup({
  control,
  name,
  label,
  color = 'standard',
  inputToggleButtons,
  ...toggleButtonGroupProps
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error}>
          {label && (
            <FormLabel
              sx={{
                color: 'text.primary',
                ml: 0,
                mt: 1,
                mb: 1
              }}
            >
              {label}
            </FormLabel>
          )}
          <ToggleButtonGroup
            exclusive
            size="small"
            color={color}
            {...toggleButtonGroupProps}
            {...field}
          >
            {(inputToggleButtons || []).map(
              ({ label, value, selected, disabled }, i: number) => (
                <ToggleButton
                  key={i}
                  size="small"
                  value={value}
                  aria-label="left aligned"
                  selected={selected}
                  disabled={disabled}
                  sx={{
                    textTransform: 'none',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {label}
                </ToggleButton>
              )
            )}
          </ToggleButtonGroup>

          <FormHelperText sx={{ ml: 0 }}>
            {fieldState?.error?.message}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
}
